import { useEffect } from 'react';

const DEFAULT_TITLE = 'SnapLogic - App & Web Development op Maat';

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | SnapLogic` : DEFAULT_TITLE;
  }, [title]);
}
